// extracted by mini-css-extract-plugin
export default {"index":"roles_index__kz+Vd","body":"roles_body__MNl7Y","toolbar":"roles_toolbar__gF9+c"};